import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import ApiService from "../../services/ApiService";
import { QUERY_KEYS } from "../keys";

export const useTrackedFacebookPages = (sponsorObjectId, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.TRACKED_FACEBOOK_PAGES, sponsorObjectId],
    queryFn: async () => {
      const response = await ApiService.getTrackedFacebookPages(sponsorObjectId);
      return response.data;
    },
    ...options,
  });
};

export const useTrackFacebookPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ pageId, name, pictureUrl, tenantId, platform, facebookPageId, username }) => ApiService.trackFacebookPage(pageId, name, pictureUrl, tenantId, platform, facebookPageId, username),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TRACKED_FACEBOOK_PAGES] });
    },
  });
};

export const useUntrackFacebookPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (pageId) => ApiService.untrackFacebookPage(pageId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TRACKED_FACEBOOK_PAGES] });
    },
  });
};

export default useTrackedFacebookPages;
